import { formatPhone } from '../../../../utils/utils';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  topSectionContainer: {
    marginBottom: 16,
    marginTop: 16,
    display: 'flex',
    flexFlow: 'row nowrap',
    gap: '30px'
  },
  field: {
    display: 'flex'
  },
  topSectionLabel: {
    color: theme.iconColor,
    fontSize: theme.headerTextFontSize,
    lineHeight: '19px',
    fontWeight: 500,
    minWidth: 'fit-content'
  },
  topSectionValue: {
    color: theme.dispatchPanelLabelValueColor,
    fontSize: theme.headerTextFontSize,
    lineHeight: '19px',
    fontWeight: 600,
    marginLeft: 8
  },
  noShrink: {
    flexShrink: 0
  },
  flexStyle: {
    flex: 1
  },
});

const FieldInfo = ({ classes, flexShrinkClass, label, value }) => {
  return (
    <span className={`${classes.field} ${classes[flexShrinkClass]}`}>
      <span className={classes.topSectionLabel}>{label}</span>
      <span className={classes.topSectionValue}>{value}</span>
    </span>
  );
};

const DriverInfoTopSection = ({ classes, driverInfo }) => {
  return (
    <div className={classes.topSectionContainer}>
      <FieldInfo
        label="Phone # :"
        value={driverInfo?.driverPhoneNumber ? formatPhone(driverInfo?.driverPhoneNumber) : ''}
        classes={classes}
        flexShrinkClass="noShrink"
      />
      <FieldInfo
        label="Device Name :"
        value={driverInfo?.driverDevice}
        classes={classes}
        flexShrinkClass="flexStyle"
      />
    </div>
  );
};

export default withStyles(styles)(DriverInfoTopSection);
